interface IconProps {
  color?: string
}

export const Calendar = ({ color }: IconProps) => {
  return (
    <svg
      aria-hidden="true"
      width="32px"
      height="32px"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.80078 10.0001C3.80078 7.31234 5.97966 5.13346 8.66745 5.13346H23.3341C26.0219 5.13346 28.2008 7.31235 28.2008 10.0001V24.6668C28.2008 27.3546 26.0219 29.5335 23.3341 29.5335H8.66745C5.97966 29.5335 3.80078 27.3546 3.80078 24.6668V10.0001ZM8.66745 6.8668C6.93696 6.8668 5.53411 8.26964 5.53411 10.0001V24.6668C5.53411 26.3973 6.93696 27.8001 8.66745 27.8001H23.3341C25.0646 27.8001 26.4674 26.3973 26.4674 24.6668V10.0001C26.4674 8.26964 25.0646 6.8668 23.3341 6.8668H8.66745Z"
        fill={color ?? 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.80078 12.4891C3.80078 12.0104 4.1888 11.6224 4.66745 11.6224L27.3341 11.6224C27.8128 11.6224 28.2008 12.0104 28.2008 12.4891C28.2008 12.9677 27.8128 13.3557 27.3341 13.3557L4.66745 13.3557C4.1888 13.3557 3.80078 12.9677 3.80078 12.4891Z"
        fill={color ?? 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.3159 2.4668C11.7945 2.4668 12.1826 2.85482 12.1826 3.33346V8.15391C12.1826 8.63256 11.7945 9.02058 11.3159 9.02058C10.8372 9.02058 10.4492 8.63256 10.4492 8.15391V3.33346C10.4492 2.85482 10.8372 2.4668 11.3159 2.4668Z"
        fill={color ?? 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.534 2.4668C21.0126 2.4668 21.4006 2.85482 21.4006 3.33346V8.15391C21.4006 8.63256 21.0126 9.02058 20.534 9.02058C20.0553 9.02058 19.6673 8.63256 19.6673 8.15391V3.33346C19.6673 2.85482 20.0553 2.4668 20.534 2.4668Z"
        fill={color ?? 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.80078 17.778C9.80078 17.2993 10.1888 16.9113 10.6674 16.9113C11.1461 16.9113 11.5342 17.2993 11.5342 17.778C11.5342 18.2566 11.1462 18.6447 10.6676 18.6447C10.1889 18.6447 9.80078 18.2566 9.80078 17.778Z"
        fill={color ?? 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.0898 17.778C15.0898 17.2993 15.4779 16.9113 15.9565 16.9113C16.4352 16.9113 16.8233 17.2993 16.8233 17.778C16.8233 18.2566 16.4353 18.6446 15.9566 18.6446C15.478 18.6446 15.0898 18.2566 15.0898 17.778Z"
        fill={color ?? 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.3788 17.778C20.3788 17.2993 20.7668 16.9113 21.2455 16.9113C21.7241 16.9113 22.1123 17.2993 22.1123 17.778C22.1123 18.2566 21.7243 18.6446 21.2456 18.6446C20.767 18.6446 20.3788 18.2566 20.3788 17.778Z"
        fill={color ?? 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.3788 22.3113C20.3788 21.8327 20.7668 21.4446 21.2455 21.4446C21.7241 21.4446 22.1123 21.8327 22.1123 22.3113C22.1123 22.79 21.7243 23.178 21.2456 23.178C20.767 23.178 20.3788 22.79 20.3788 22.3113Z"
        fill={color ?? 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.0898 22.3113C15.0898 21.8327 15.4779 21.4446 15.9565 21.4446C16.4352 21.4446 16.8233 21.8327 16.8233 22.3113C16.8233 22.79 16.4353 23.178 15.9566 23.178C15.478 23.178 15.0898 22.79 15.0898 22.3113Z"
        fill={color ?? 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.80086 22.3113C9.80086 21.8327 10.1889 21.4446 10.6675 21.4446C11.1462 21.4446 11.5343 21.8327 11.5343 22.3113C11.5343 22.79 11.1463 23.178 10.6677 23.178C10.189 23.178 9.80086 22.79 9.80086 22.3113Z"
        fill={color ?? 'currentColor'}
      />
    </svg>
  )
}
